export { default } from "./src/sub-product";

export type { UniformsubProductProps } from "./src/sub-product";
